var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-select',{attrs:{"filterable":true,"clearable":true,"value":_vm.value},on:{"input":_vm.input}},_vm._l((_vm.list),function(item,key){return _c('i-option',{key:key,attrs:{"label":_vm.get_label(item),"value":item.id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }